import Service from "../../Service";

const resource = "visit/";

export default {
    
    save(parameters, requestID) {
        return Service.post(resource + "savePhenological", parameters, {
            params: {
                requestID: requestID,
            },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "paginationPhenological", parameters, {
            params: { requestID }
        });
    }
};